import { SurveyInstance } from 'app/entities/surveys/survey-instance.model';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs/Observable';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { Injectable } from '@angular/core';

import { ConstantsService } from 'app/services/constants-service';
import { BankInstitution } from 'app/shared/models/bank-institution.model';
import { ExecutiveSummary } from 'app/shared/models/executive-summary.model';

@Injectable()
export class EntityCafService {
    constructor(private requestService: ObservableRequestService) {
    }

    getBankAccountsForEntity(entityId: number): Observable<any> {
        const clientAccountsURL = `${ConstantsService.BANK_INSTITUTIONS_ACCOUNTS_ENDPOINT}/${entityId}`;
        return this.requestService.getRequest(clientAccountsURL)
            .map(response => {
                return plainToClass(BankInstitution, response.arrResult as Object[]);
            });
    };

    getSurveyDetails(entityId: number): Observable<any> {
        const surveyDetailsUrl = ConstantsService.SURVEY_DETAIL + '/' + entityId + '/Intro';
        return this.requestService.getRequest(surveyDetailsUrl).map(response => {
            return plainToClass(SurveyInstance, response.arrResult as Object[]);
        });
    };

    getExecutiveSummary(entityId: number): Observable<any> {
        const executiveSummaryURL =
            `${ConstantsService.RELATIONSHIP_ENTITY}/${entityId}${ConstantsService.GET_EXECUTIVE_SUMMARY}`;
        return this.requestService.getRequest(executiveSummaryURL)
            .map(response => {
                return plainToClass(ExecutiveSummary, response.arrResult as Object);
            });
    };
}



// WEBPACK FOOTER //
// ./src/app/entities/caf/entity-caf.service.ts